
import {
  getConversationById,
  getMessagesAll,
  getuttrnaceAll,
  removeMessages,
  getConversationAll,
  getAllConversationbyBot,
  getMessageConversation,
  trainBot,
  publishBot,
  addMessage,
  addConversation,
  updateMessages,
  removeConversation,
  updateConversation
} from '../api/conversation.service.js'

import {
  getBotById
} from '@/api/bot.service.js'

export default {
  state: {
    conversation: {},
    conversations: [],
    messages: [],
    message: {},
    train: '',
    publish: ''
  },
  getters: {
    
    getAllConversation(state) {
      return state.conversations
    },
    getConversationAll(state) {
      return state.conversations
    },
    getConversation(state) {
      return state.conversation
    },
    getMessages(state) {
      return state.conversation.messages
    },
    getMessagesAll(state) {
      return state.messages
    },
    getuttrnaceAll(state) {
      return state.messages
    },
    getTrain(state) {
      return state.train
    },
    getPublish(state) {
      return state.publish
    }


  },

  mutations: {
    setAllConversation(state, convs) {
      state.conversations = convs
    },
    updateMessages(state, convs) {
      state.messages = convs
    },
    setAllMessages(state, convs) {
      state.messages = convs
    },
    setAllConve(state, convs) {
      state.conversations = convs
    },
    setConversationById(state, newconv) {
      state.conversation = newconv
    },
    addConversation(state, newconv) {
      state.conversation = newconv
    },
    addMessage(state, msgs){
      state.conversation = msgs
    },

    setTrain(state, train) {
      state.train = train
    },
    setpublish(state, publish) {
      state.publish = publish
    },
    clearCurrentConversation(state, obj){
      state.conversation =obj
    }
  },
  actions: {
    clearConversation(context, obj){
      context.commit('clearCurrentConversation', obj)
    },
    async setAllMessages(context, idBot) {
     // console.log("loooooooooool")
      // let convs = await getMessagesAll(idBot)
      let convs = await getuttrnaceAll(idBot)
 
      context.commit('setAllMessages', convs)
    },

    
    async setAllConversation(context) {
      let convs = await getConversationAll()
      context.commit('setAllConversation', convs)
    },
   
    async setAllConve(context, id) {
      let conversation = await getAllConversationbyBot(id)
     context.commit('setAllConve', conversation)
    },
    async setConversationById(context, id) {
      let conv = await getConversationById(id)
      context.commit('setConversationById', conv)
    },
   async addConversation(context, conv) {
      let newConversation = await addConversation(conv)
      context.commit('addConversation', newConversation)
    },
    async addMessage(context, conv) {
      let convMs = await addMessage(conv)
      context.commit('addMessage', convMs)
    },
    
    async updateMessages(context, obj) {
      let msgsR = await updateMessages(obj)
      context.commit('setAllMessages', msgsR)
    },
    
    async removeMessages(context, obj) {
      let msgsR = await removeMessages(obj)
      console.log("stoore remove ", msgsR)
      context.commit('setAllMessages', msgsR)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/conversation.store.js